<template>
  <div class="login">
    <div class="bg-wrap"></div>
    <div class="main">
      <div class="logo">
        <img src="../assets/logo.png" :alt="$t('logo')">
      </div>
      <!-- 语言切换 -->
      <div class="language">
        <!-- <i class="iconfont iconzhongyingwenqiehuan-EN" v-if="isEn"></i>
        <i class="iconfont iconzhongyingwenqiehuan-zhong ch-zn" v-else></i> -->
        <el-select v-model="language" @change="changeLanguages">
          <el-option
            v-for="item in languageArr"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <!-- <SliderVerification /> -->
      <div class="system-title">
        <h1>
          {{ $t('systemName') }}
        </h1>
      </div>
      <div class="login-form">
        <el-tabs v-model="activeName" @tab-click="changeType">
          <el-tab-pane :label="$t('signIn')" name="login">
            <div class="login-form-item">
              <div class="item-label"><i class="iconfont icon-yonghu"></i></div>
              <div class="item-content"><el-input autocomplete="off" v-model="account" :placeholder="$t('emailAddress')"></el-input></div>
            </div>
            <div class="login-form-item">
              <div class="item-label"><i class="iconfont icon-mima"></i></div>
              <div class="item-content">
                <el-input type="password" autocomplete="off" v-model="password" @keyup.enter.native="handleClick"
                  :placeholder="$t('password')"/>
              </div>
            </div>
            <div class="other">
              <div class="remember-me"><el-checkbox v-model="isRemember">{{ $t('rememberMe') }}</el-checkbox></div>
              <div class="forgot-password" @click="handleForget">{{ $t('forgotPassword') }}</div>
            </div>
            <el-button class="login-btn" :loading="loading" @click="handleClick">{{ $t('signIn') }}</el-button>
          </el-tab-pane>
          <el-tab-pane :label="$t('register')" name="register">
             <div class="login-form-item require">
              <!-- <div class="item-label"><img src="../assets/account.png" alt="email"></div> -->
              <div class="item-label"><i class="iconfont icon-youxiang"></i></div>
              <div class="item-content"><el-input v-model="registerData.email" :placeholder="$t('emailAddress')"></el-input></div>
            </div>
            <!-- <div class="login-form-item require">
              <div class="item-label"><i class="iconfont icon-yonghu"></i></div>
              <div class="item-content"><el-input v-model="registerData.loginName" :placeholder="$t('name')"></el-input></div>
            </div> -->
            <div class="login-form-item require">
              <div class="item-label"><i class="iconfont icon-mima"></i></div>
              <div class="item-content">
                <el-input v-model="registerData.password" type="password" show-password :placeholder="$t('password')" />
              </div>
            </div>
            <div class="login-form-item require">
              <div class="item-label"><i class="iconfont icon-mima"></i></div>
              <div class="item-content">
                <el-input v-model="registerData.confirmPassword" show-password type="password" :placeholder="$t('confirmPassword')" />
              </div>
            </div>
            <div class="login-form-item">
              <div class="item-label"><i class="iconfont icon-shouji1"></i></div>
              <div class="item-content">
                <el-input v-model="registerData.phone" :placeholder="$t('phone')">
                </el-input>
              </div>
            </div>
            <div class="more">
              <div class="left-line"></div>
              <div class="center">{{ $t('optionalInformation') }}</div>
              <div class="right-line"></div>
            </div>
            <div class="arrow" :class="showMore ? 'flipy' : ''">
              <i class="iconfont icon-2014082601545126easyiconnet-copy-copy-copy pointer" @click="showMore = !showMore"></i>
            </div>
            <div class="login-form-item" v-if="showMore" style="margin-top: 2px">
              <div class="item-label"><i class="iconfont icon-id"></i></div>
              <div class="item-content">
                <el-input v-model="registerData.customerId" :placeholder="$t('customerIdCode')">
                </el-input>
              </div>
            </div>
            <div class="login-form-item" v-if="showMore">
              <div class="item-label"><i class="iconfont icon-yonghu"></i></div>
              <div class="item-content">
                <el-input v-model="registerData.customerName" :placeholder="$t('customerName')">
                </el-input>
              </div>
            </div>
            <div class="login-form-checkbox">
              <el-checkbox v-model="checked"></el-checkbox>
              <template v-if="language === 'spanish'">al registrarme acepto los <span @click="linkToPolicy">términos y condiciones</span></template>
              <template v-else-if="language === 'portuguese'">ao registar-me, eu aceito os  <span @click="linkToPolicy"> termos e condições</span></template>
              <template v-else>by registering I accept the <span @click="linkToPolicy">terms and conditions</span></template>
            </div>
            <div style="position: relative">
              <el-button class="login-btn" style="margin-bottom: 20px" @click="registerUser(false)">{{ $t('register') }}</el-button>
              <div v-show="verificationVisile" class="container-wrap">
                <div id="container"></div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        class="modal"
        title="Prompt"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <div class="dialog-title" slot="title">
          {{ $t('forgotPassword') }}
        </div>
        <span>{{ $t('sureResetPassword') }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button class="gray-btn" @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
          <el-button class="blue-btn" :loading="resetLoading" @click="resetPassword">{{ $t('sure') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import SliderVerification from '../components/SliderVerification'
import { mapActions } from 'vuex'
import { login, register, resetPassword } from '../api/user'
import config from '../common/config'
import Cookies from 'js-cookie'
// import config from '../config/config'
import base64 from '../common/config/base64'
import 'jigsaw'

export default {
  name: 'Login',
  data () {
    return {
      account: '',
      password: '',
      isEn: true,
      loading: false,
      activeName: 'login',
      dialogVisible: false,
      resetLoading: false,
      registerData: {
        email: '',
        // loginName: '',
        language: '2', // 默认英语
        password: '',
        confirmPassword: '',
        phone: '',
        customerId: '',
        customerName: ''
      },
      showMore: false,
      isRemember: false,
      verificationVisile: false,
      language: Cookies.get(config.language) || 'english',
      checked: false,
      languageArr: [{
        name: 'English',
        value: 'english'
      }, {
        name: 'Español',
        value: 'spanish'
      }, {
        name: 'Português',
        value: 'portuguese'
      }]
    }
  },
  mounted () {
    const _account = localStorage.getItem(base64.btoaUTF16(config.account))
    const _password = localStorage.getItem(base64.btoaUTF16(config.password))
    if (_account && _password) {
      this.account = base64.atobUTF16(_account)
      this.password = base64.atobUTF16(_password)
      if (this.account && this.password) {
        this.isRemember = true
      }
    }
    // 这里默认设置language为英语
    // Cookies.set(config.language, this.language)
    // console.log(Cookies.get(config.language))
    window.jigsaw.init({
      el: document.getElementById('container'),
      width: 310, // 可选, 默认310
      height: 155, // 可选, 默认155
      onSuccess: this.canRegisterUser,
      onClose: () => {this.verificationVisile = false }
      // onFail: function () { alert(2) },
      // onRefresh: function () { alert(3) }
    })
  },
  methods: {
    ...mapActions([
      'changeUser',
      'changeLanguage'
    ]),
    changeType () {
      // todo
    },
    handleClick () {
      if (!this.account || !this.password) {
        this.$message.error(this.$t('loginCheck'))
        return
      }
      const params = {
        loginName: this.account,
        password: this.password
      }
      this.loading = true
      login(params).then(res => {
        this.loading = false
        Cookies.set(config.tokenName, res.data.token, { expires: 0.25})
        Cookies.set(config.accoutName, res.data.userName, { expires: 0.25})
        Cookies.set(config.role, res.data.roleId, { expires: 0.25})
        Cookies.set(config.userId, res.data.userId, { expires: 0.25})
        // 记住密码
        if (this.isRemember) {
          localStorage.setItem(base64.btoaUTF16(config.account), base64.btoaUTF16(this.account))
          localStorage.setItem(base64.btoaUTF16(config.password), base64.btoaUTF16(this.password))
        } else {
          localStorage.setItem(base64.btoaUTF16(config.account), '')
          localStorage.setItem(base64.btoaUTF16(config.password), '')
        }
        this.$router.replace({ path: '/configuration' })
      }).catch(() => {
        this.loading = false
      })
    },
    // 显示重置密码
    handleForget () {
      if (!this.account) {
        this.$message.error(this.$t('accountEmpty'))
        return
      }
      this.dialogVisible = true
    },
    // 重置密码
    resetPassword () {
      if (!this.account) {
        this.$message.error(this.$t('accountEmpty'))
        return
      }
      this.resetLoading = true
      resetPassword({
        loginName: this.account,
        lan: this.language
      }).then(res => {
        this.resetLoading = false
        this.dialogVisible = false
        this.$message.success(this.$t('resetPasswordSuccess'))
      }).catch(() => {
        this.resetLoading = false
      })
    },
    changeLanguages () {
      // this.isEn = !this.isEn
      // Cookies.set(config.language, this.isEn ? 'en' : 'zh')
      // this.$i18n.locale = this.isEn ? 'en' : 'zh'
      // this.changeLanguage(this.isEn)
      // window.location.reload()
      Cookies.set(config.language, this.language)
      this.$i18n.locale = this.language
      window.location.reload()
    },
    registerUser (canRegisterUser = false) {
      if (!this.registerData.email) {
        this.$message.error(this.$t('emailEmpty'))
        return
      }
      // if (!this.registerData.loginName) {
      //   this.$message.error(this.$t('nameEmpty'))
      //   return
      // }
      if (!this.registerData.password) {
        this.$message.error(this.$t('passwordEmpty'))
        return
      }
      if (!this.registerData.confirmPassword) {
        this.$message.error(this.$t('confirmPasswordEmpty'))
        return
      }
      if (this.registerData.confirmPassword !== this.registerData.password) {
        this.$message.error(this.$t('checkConfirmSame'))
        return
      }
      // if (!this.registerData.phone) {
      //   this.$message.error(this.$t('phoneEmpty'))
      //   return
      // }
      if (!this.checked) {
        this.$message.error(this.$t('unagree'))
        return
      }
      this.registerData.lan = this.language
      this.verificationVisile = true
      if (canRegisterUser) {
        register(this.registerData).then(res => {
          this.$message.success(this.$t('registerSuccess'))
          this.verificationVisile = false
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        })
      }
    },
    canRegisterUser () {
      this.registerUser(true)
    },
    linkToPolicy () {
      window.open('./termCondition.html')
    }
  }
}
</script>

<style lang="less" scoped>
@login-base: #81D5FF;
.bg-wrap {
  position:fixed;
  top: 0;
  left: 0;
  width:100%;
  height:100%;
  min-width: 1366px;
  z-index:-10;
  zoom: 1;
  background: url(../assets/bg.png) no-repeat;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.main {
  .logo {
    margin: 27px 0 0 31px;
  }
  .system-title {
    margin: 86px 0 0 122px;
    h1 {
      font-weight: normal;
      color: #fff;
      font-size: 56px;
    }
  }
  .login-form {
    width: 400px;
    margin: 80px 0 0 120px;
    img {
      margin: 4px;
    }
    .el-input__inner {
      background-color: transparent;
    }
    .login-form-item {
      display: flex;
      justify-content: space-between;
      width: 358px;
      height: 38px;
      line-height: 38px;
      margin: 30px auto;
      border-bottom: 2px solid @login-base;
      position: relative;
      .item-label {
        width: 50px;
      }
      .item-content {
        width: 300px;
      }
    }
    .login-btn {
      margin: 20px 0 0 20px;
      width: 360px;
      height: 58px;
      border: none;
    }
    .other {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
    }
    .forgot-password {
      text-align: right;
      color: @login-base;
      font-size: 14px;
      cursor: pointer;
    }
    .el-tabs__item {
     color: #FFF;
    }
  }
  .language {
    position: fixed;
    top: 37px;
    right: 31px;
    width: 120px;
    color: #AFFDFF;
    // i {
    //   font-size: 44px;
    //   cursor: pointer;
    // }
    // .ch-zn {
    //   position: relative;
    //   top: -1px;
    // }
  }
}
.login {
  .container-wrap {
    position: absolute;
    background: #fff;
    left: 36px;
    top: -280px;
    padding: 8px 8px 0;
    border-radius: 4px;
  }
  .class {
    position: absolute;
  }
  .login-form-checkbox {
    padding-left: 20px;
    color: #fff;
    span {
      color: #81D5FF;
      cursor: pointer;
    }
  }
}
</style>

<style lang="less">
.sliderContainer {
  background: #eee;
}
@login-base: #81D5FF;
.login-form {
  .el-input .el-input__clear {
    color: @login-base;
  }
  .el-input__inner {
    background-color: transparent;
    border: none;
    font-size: 14px;
    color: @login-base;
  }
  i {
    color: @login-base;
    font-size: 28px;
  }
  .more {
    margin: 0 20px;
    font-size: 16px;
    color: #fff;
    height: 20px;
    line-height: 20px;
    display: flex;
    justify-content: space-between;
    .center {
      flex-shrink: 1;
      white-space: nowrap;
    }
    .left-line {
      flex-shrink: 2;
      height: 9px;
      width: 100px;
      border-bottom: 1px solid #FFF;
    }
    .right-line {
      flex-shrink: 2;
      height: 9px;
      width: 100px;
      border-bottom: 1px solid #FFF;
    }
  }
  .arrow {
    color: #fff;
    margin-top: 10px;
    text-align: center;
    i{
      font-size: 20px;
    }
  }
  .el-input__inner::-webkit-input-placeholder {
    color: @login-base!important;
  }
  .el-button {
    background: #24BBEE;
    font-size: 25px;
    color: #FFF;
  }
  .el-tabs {
    .el-tabs__item {
      color: @color-white;
      font-size: 18px;
      cursor: pointer;
    }
    .is-active {
      color: @login-base;
      font-size: 18px;
    }
    .el-tabs__nav-wrap::after {
      display: none;
    }
    .el-tabs__active-bar {
      background-color: @login-base;
    }
    .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }
  }
  .el-checkbox {
    .el-checkbox__label {
      color: @color-white!important;
    }
    .is-checked {
      .el-checkbox__inner {
        background-color: @login-base!important;
        border-color: @login-base!important;
      }
    }
  }
  .require:after {
    content: '*';
    position: absolute;
    color: red;
    right: -20px;
    font-size: 30px;
    top: 5px;
  }
}
// 避免登录页面的下拉框底部多余的空白
.el-scrollbar__wrap {
  overflow: unset;
}
</style>
